module.exports = __webpack_public_path__ + "img/11.20fdf44b.png";